import _ from "lodash";

const topicSchoolIncrease = 10;
const energyCost = -3.5;

export const actions = {
  sleepFree: {
    topic: "sleep",
    style: "free",
    modifiers: {
      energy: 8,
      fun: -1,
    }
  },
  gamingFree: {
    topic: "gaming",
    style: "free",
    modifiers: {
      energy: 0.8 * energyCost,
      fun: 8
    }
  },
  chill: {
    topic: "chill",
    style: "free",
    modifiers: {
      fun: -1,
      energy: +1
    }
  },
  mathFree: {
    topic: "math",
    style: "free",
    modifiers: {
      energy: energyCost,
      math: topicSchoolIncrease,
      fun: -4,
    }
  },
  mathSchool: {
    topic: "math",
    style: "school",
    modifiers: {
      energy: energyCost,
      math: topicSchoolIncrease,
      fun: -4,
    }
  },
  mathExam: {
    topic: "math",
    style: "exam",
    modifiers: {
      energy: energyCost,
      fun: -4,
    }
  },
  frenchSchool: {
    topic: "french",
    style: "school",
    modifiers: {
      energy: energyCost,
      french: topicSchoolIncrease,
      fun: -4,
    }
  },
  frenchFree: {
    topic: "french",
    style: "free",
    modifiers: {
      energy: energyCost,
      french: topicSchoolIncrease,
      fun: -4,
    }
  },
  sportSchool: {
    topic: "sport",
    style: "school",
    modifiers: {
      energy: 1.5 * energyCost,
      sport: topicSchoolIncrease,
      fun: +4,
    }
  },
  sportFree: {
    topic: "sport",
    style: "free",
    modifiers: {
      energy: 1.5 * energyCost,
      sport: topicSchoolIncrease,
      fun: +4,
    }
  },
  sportExam1: {
    topic: "sport",
    style: "exam",
    needed: 50
  },
  sportExam2: {
    topic: "sport",
    style: "exam",
    needed: 75
  },
  frenchExam1: {
    topic: "french",
    style: "exam",
    needed: 50
  },
  frenchExam2: {
    topic: "french",
    style: "exam",
    needed: 75
  },
  mathExam1: {
    topic: "math",
    style: "exam",
    needed: 50
  },
  mathExam2: {
    topic: "math",
    style: "exam",
    needed: 75
  },
};

function multiplierByValue(value) {
  let result = 1;
  if(value > 75) {
    result = 1.25;
  } else if(value > 40) {
    result = 1;
  } else {
    result = 0.75;
  }
  return result;
}

const initialSchoolValue = 40;
const forgetFactor = 0.85;

export class GameEngine {
  constructor() {
    this.reset();
  }

  reset() {
    Object.assign(this, {
      energy: 80,
      fun: 80,
      math: initialSchoolValue,
      french: initialSchoolValue,
      sport: initialSchoolValue,
      actionQueue: [],
      gameOver: false,
      gameOverReason: "",
    });

    this.fillQueue();
  }

  performAction(actionObject, slotIndex) {
    if(actionObject.style === "exam") {
      console.log("playExam");
      const actualPoints = Math.floor(this[actionObject.topic]);
      const neededPoints = actionObject.needed;
      if(actualPoints < neededPoints) {
        console.log("exam failed");
        this.gameOver = true;
        this.gameOverReason = {
          title: `Exam failed!<br>You have ${actualPoints} points in ${actionObject.topic} but you need at least ${neededPoints} points.`,
          exam: actionObject
        };
      } else {
        console.log("exam great");
      }
    } else {
      const modifiers = Object.assign({
        energy: 0,
        fun: 0,
        math: 0,
        french: 0,
        sport: 0
      }, actionObject.modifiers);

      this.energy = Math.min(100, this.energy + modifiers.energy);
      this.fun = Math.min(100, this.fun + modifiers.fun);
      this.math = Math.min(100, this.math + modifiers.math * multiplierByValue(this.fun) * multiplierByValue(this.energy));
      this.french = Math.min(100, this.french + modifiers.french * multiplierByValue(this.fun) * multiplierByValue(this.energy));
      this.sport = Math.min(100, this.sport + modifiers.sport * multiplierByValue(this.fun) * multiplierByValue(this.energy));
    }
  }

  update(slotIndex) {
    if(this.gameOver) {
      console.log("game over");
    } else {
      console.log(slotIndex);
      this.performAction(this.actionQueue[slotIndex], slotIndex);
      if((slotIndex + 1) % 5 === 0) {
        console.log("day update");
        this.dayUpdate();
      }
    }
  }

  playWeek(weekIndex) {
    this.update(weekIndex);
    this.update(weekIndex + 1);
    this.update(weekIndex + 2);
    this.update(weekIndex + 3);
    this.update(weekIndex + 4);

    this.update(weekIndex + 5);
    this.update(weekIndex + 6);
    this.update(weekIndex + 7);
    this.update(weekIndex + 8);
    this.update(weekIndex + 9);

    this.update(weekIndex + 10);
    this.update(weekIndex + 11);
    this.update(weekIndex + 12);
    this.update(weekIndex + 13);
    this.update(weekIndex + 14);

    this.update(weekIndex + 15);
    this.update(weekIndex + 16);
    this.update(weekIndex + 17);
    this.update(weekIndex + 18);
    this.update(weekIndex + 19);

    this.update(weekIndex + 20);
    this.update(weekIndex + 21);
    this.update(weekIndex + 22);
    this.update(weekIndex + 23);
    this.update(weekIndex + 24);
  }

  dayUpdate() {
    this.math = Math.floor(this.math * forgetFactor);
    this.french = Math.floor(this.french * forgetFactor);
    this.sport = Math.floor(this.sport * forgetFactor);
    this.energy -= 1;

    if(this.energy <= 0) {
      this.gameOver = true;
      this.gameOverReason = {
        title: "not enough energy"
      };
    }
  }

  totalPoints() {
    return this.math + this.french + this.sport + this.energy + this.fun;
  }

  printPoints() {
    console.log(`energie: ${Math.floor(this.energy)}, fun: ${Math.floor(this.fun)}, math: ${Math.floor(this.math)}, french: ${Math.floor(this.french)}, sport: ${Math.floor(this.sport)}`);
  }

  setNextSlot(slotIndex, actionName) {
    if(this.actionQueue[slotIndex].style !== "school" && this.actionQueue[slotIndex].style !== "exam") {
      // update actionQueue this otherwise Vue will not see the update in `getters`
      this.actionQueue.splice(slotIndex, 1, actions[actionName]);
    }
  }

  fillQueue() {
    let slotsPerDay = 5;
    let weeks = 6;
    this.actionQueue = [];

    _.range(weeks).forEach(week => {
      _.range(5).forEach(day => {
        _.range(slotsPerDay).forEach(slot => {
          if(slot === 0) {
            this.actionQueue.push(actions.sleepFree);
          } else if(slot === 1 && (day === 0 || day === 3)) {
            this.actionQueue.push(actions.mathSchool);
          } else if(slot === 1 && (day === 1 || day === 4)) {
            this.actionQueue.push(actions.frenchSchool);
          } else if(slot === 1 && (day === 2)) {
            this.actionQueue.push(actions.sportSchool);
          } else if(slot === 4 && day === 4) {
            if(week === 0) {
              this.actionQueue.push(actions.sportExam1);
            }
            if(week === 1) {
              this.actionQueue.push(actions.frenchExam1);
            }
            if(week === 2) {
              this.actionQueue.push(actions.mathExam1);
            }
            if(week === 3) {
              this.actionQueue.push(actions.sportExam2);
            }
            if(week === 4) {
              this.actionQueue.push(actions.frenchExam2);
            }
            if(week === 5) {
              this.actionQueue.push(actions.mathExam2);
            }
          } else {
            this.actionQueue.push(actions.chill);
          }

        });
      });
    });
  }
}
